const sceneImage = "/images/scene-02.png";

function Scene02({ onNext }) {
  return (
    <>
      {/* Background */}
      <img
        src={sceneImage}
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* Header */}
      <div className="absolute inset-x-4 top-7 z-10 text-center">
        <h1 className="font-playful text-[1.3rem] font-bold leading-none text-white drop-shadow-[0_4px_4px_rgba(0,0,0,0.45)]">
          BIRTHDAY PERFORMANCE!
        </h1>

        <h1 className="font-playful text-[2.3rem] font-bold leading-none text-white drop-shadow-[0_4px_4px_rgba(0,0,0,0.45)]">
          BOYS WHO CRY
        </h1>

        {/* <div className="mx-auto mt-3 w-fit rounded-2xl border-2 border-[#8a5a32] bg-[#f5d49a] px-5 py-2 shadow-[0_4px_0_#8a5a32]">
          <p className="font-playful text-xl font-bold text-[#4b3024]">
            KHUSUS UNTUK AINI 💕
          </p>
        </div> */}
      </div>

      {/* Bottom Content */}
      <div className="absolute inset-x-5 bottom-0 z-10 pb-[calc(1.75rem+env(safe-area-inset-bottom))] text-center">
        {/* <p className="font-playful text-lg font-semibold text-white drop-shadow-[0_3px_4px_rgba(0,0,0,0.5)]">
          Ada yang mau nyanyi khusus buat kamu... 🎤
        </p> */}

        <button
          onClick={onNext}
          className="mt-5 w-full rounded-full border-2 border-[#9a5b08] bg-[#ffd447] px-6 py-4 font-playful text-xl font-bold text-[#3d2b1f] shadow-[0_6px_0_#9a5b08] transition-all duration-100 hover:bg-[#ffe071] active:translate-y-[5px] active:shadow-[0_1px_0_#9a5b08]"
        >
          LANJUT KE HADIAH
        </button>
      </div>
    </>
  );
}

export default Scene02;
